module.exports = __webpack_public_path__ + "static/media/JustAct Blog Creative 20.03.23.f48700e7.jpg";